import React from 'react';
import './internal-notes.scss';
import { SVGS } from '../../assets';
import { MessageKebabMenu } from '../message-kebab-menu/message-kebab-menu';

export const InternalNotes: React.FC<{
  note: string;
  time: string;
}> = ({ note, time }) => {
  return (
    <div className="internal-notes-container">
      <div className="internal-notes-container-header">
        <div className="internal-notes-container-header-left font-semibold">
          <img src={SVGS.NotepadOrange} alt="" />
          Internal Note
        </div>
        <div className="internal-notes-container-header-right font-regular">
          <div className="internal-notes-container-header-right-time">
            <img src={SVGS.Clock} alt="" />
            {time}
          </div>
          <div className="internal-notes-container-header-right-menu">
            <MessageKebabMenu />
          </div>
        </div>
      </div>
      <div className="internal-notes-container-body font-regular">{note}</div>
    </div>
  );
};
